import { IPolicyScan } from 'types';
import { getGlobalIdTokenClaims, getUserId } from './auth-context';
import { getDeviceType, isVehiclePolicy } from 'helpers';
import { analytics } from '../analytics';

const propsToOmit = ['dateOfBirth', 'firstName', 'lastName', 'summary'];

export enum FB_EVENTS {
  Subscribe = 'Subscribe',
  CompleteRegistration = 'CompleteRegistration',
  AddToCart = 'AddToCart',
  Contact = 'Contact',
  Purchase = 'Purchase',
  Schedule = 'Schedule',
  Search = 'Search',
}

export enum REDDIT_EVENTS {
  SIGN_UP = "Signed Up",
  Purchase = 'Order Completed',
  AddToCart = 'Product Added',
}

export enum PAGE_VIEW_EVENTS {
  Home = 'Web-App-Home-Page',
  Dashboard = 'Web-App-Dashboard-Page',
  PolicyDetails = 'Web-App-Policy-Details-Page',
  ExploreStart = 'Web-App-Discover-Insurance-Page',
  ExploreCategory = 'Web-App-Discover-Category-Page',
  ExplorePolicy = 'Web-App-Discover-Policy-Page',
  GetAdvice = 'Web-App-Get-Advice-Page',
  GetAdviceClickBooking = 'Web-App-Get-Advice-Click-Booking',
  GetAdviceCalendlyBooked = 'Web-App-Get-Advice-Calendly-Booked',
  GetAdviceSelection = 'Web-App-Get-Advice-Selection-Page',
  InsuranceCheckup = 'Web-App-Insurance-Checkup-Page',
  MarketScan = 'Web-App-Market-Scan-Page',
  MarketScanBroker = 'Web-App-Market-Scan-Page-Broker-Selection-Page',
  MarketScanAddPolicy = 'Web-App-Market-Scan-Add-Policy-Page',
  MarketScanComparePolicy = 'Web-App-Market-Scan-Compare-Policy-Page',
  MarketScanNoPolicy = 'Web-App-Market-Scan-No-Policy-Page',
  MarketScanLifeReferral = 'Web-App-Market-Scan-Life-Referral',
  MarketScanPurchase = 'Web-App-Market-Scan-Purchase-Page',
  MarketScanBrokerConfirmation = 'Web-App-Market-Scan-Broker-Confirmation-Page',
  CreditCard = 'Web-App-Explore-Credit-Card-Page',
  ProcessInvitation = 'Web-App-Process-Invitation-Page',
  Share = 'Web-App-Share-Policy-Page',
  User = 'Web-App-User-Profile-Page',

  // Market Scan
  MarketScanLifeStart = 'Web-App-Market-Scan-Life-Start',
  MarketScanLifeForm = 'Web-App-Market-Scan-Life-Form-1',
  MarketScanLifeResults = 'Web-App-Market-Scan-Life-Results-Page',


  // Market Scan MBI
  MarketScanMBI = 'Web-App-Market-Scan-MBI',
  MarketScanMBISuccess = 'Web-App-Market-Scan-MBI-Success',
  MarketScanMBIError = 'Web-App-Market-Scan-MBI-Error',
  MarketScanMBIOdometerError = 'Web-App-Market-Scan-MBI-ODOMETER-ERROR',
  MarketScanMBIAdLearnMore = 'Web-App-MBI-Ad-Learn-More-Click',

  // Premium
  Premium = 'Web-App-Premium-Page',

  // Onboarding
  OnboardingAccountSetupPage = 'Web-App-Onboarding-Account-Setup-Page',
  OnboardingIntroPage = 'Web-App-Onboarding-Intro-Page',
  OnboardingOptionsPage = 'Web-App-Onboarding-Options-Page',
  OnboardingUploadPage = 'Web-App-Onboarding-Upload-Page',
  OnboardingMarketScanPage = 'Web-App-Onboarding-Market-Scan-Page',

  // Q4E
  Q4EOnboardingStart = 'Web-App-Q4E-Onboarding-Start-Page',
  Q4EEmailConfirmation = 'Web-App-Q4E-Email-Confirmation-Page',
  Q4EEmailVerification = 'Web-App-Q4E-Email-Verification-Page',
  Q4EWorkplace = 'Web-App-Q4E-Workplace-Page',
  Q4ELifeOffers = 'Web-App-Q4E-Life-Offers-Page',
  Q4EConfirmPurchase = 'Web-App-Q4E-Confirm-Purchase-Page',

  // Renewal
  RenewalSummaryPage = 'Web-App-Renewal-Summary-Page',
}

export enum TRACKING_EVENTS {
  // App
  UserLogin = 'User Log In',
  HomeCardClick = 'Web-App-Home-Card-Click',
  NotificationClick = 'Web-App-Notification-Click',
  NotificationViewAll = 'Web-App-Notification-View-All-Click',
  ZoomSupportCheck = 'Web-App-Zoom-Support-Check',

  GetAdviceSubmitted = 'Web-App-Get-Advice-Submitted',
  InsuranceCheckupCompleted = 'Web-App-Insurance-Checkup-Completed',
  FeedbackUpvote = 'Web-App-Feedback-Vote-Upvote',
  FeedbackDownvote = 'Web-App-Feedback-Vote-Downvote',
  FeedbackNotes = 'Web-App-Feedback-Notes',
  LifeCalculatorNext = 'Web-App-Life-Calculator-Next',

  // Add policy
  AddPolicyMSClick = 'Web-App-Add-Policy-Market-Scan-Click',
  PolicyAddedUpload = 'Web-App-Policy-Added-Upload',
  PolicyAddedManual = 'Web-App-Policy-Added-Manual',

  // Explore
  ExploreCategoryBannerClick = 'Web-App-Explore-Category-Banner-Click',
  ExploreLifeCtaClick = 'Web-App-Explore-Life-Cta-Click',

  // Get Advice
  GetAdviceSelect = 'Web-App-Get-Advice-Select',

  // Market Scan
  MarketScanSubmitted = 'Web-App-Market-Scan-Submitted',
  MarketScanNoPolicySubmitted = 'Web-App-Market-Scan-No-Policy-Submitted',
  MarketScanCallbackSubmitted = 'Web-App-Market-Scan-Callback-Submitted',
  MarketScanViewClick = 'Web-App-Market-Scan-View-Click',
  MarketScanBuy = 'Web-App-Market-Scan-Buy',
  MarketScanRequestQuote = 'Web-App-Market-Scan-Request-Quote',
  MarketScanViewed = 'Web-App-Market-Scan-Viewed',
  MarketScanLifeBuy = 'Web-App-Market-Scan-Life-Buy',
  MarketScanPageChange = 'Web-App-Market-Scan-Page-Change',
  MarketScanPurchasePageChange = 'Web-App-Market-Scan-Purchase-Page-Change',
  MarketScanPurchaseSaveDraft = 'Web-App-Market-Scan-Purchase-Save-Draft',
  MarketScanPurchasePay = 'Web-App-Market-Scan-Purchase-Pay',
  MarketScanPurchaseStripePay = 'Web-App-Market-Scan-Purchase-Stripe-Pay',
  MarketScanPurchaseSuccess = 'Web-App-Market-Scan-Purchase-Success',
  MarketScanPurchaseFail = 'Web-App-Market-Scan-Purchase-Fail',
  MarketScanPurchaseTermsDownload = 'Web-App-Market-Scan-Purchase-Terms-Download',
  MarketScanPolicyTypeSelect = 'Web-App-Market-Scan-Policy-Type-Select',
  MarketScanDisclosureClick = 'Web-App-Market-Scan-Disclosure-Click',
  MarketScanRiskProperty = 'Web-App-Market-Scan-Risk-Property',
  MarketScanEndScreenCta = 'Web-App-Market-Scan-End-Screen-Cta',
  MarketScanEndScreenAreYouCoveredCta = 'Web-App-Market-Scan-End-Screen-Are-You-Covered-Cta',
  MarketScanEndScreenIncentiveClick = 'Web-App-Market-Scan-End-Screen-Incentive-Click',
  MarketScanCompareExistingClick = 'Web-App-Market-Scan-Compare-Existing-Click',
  MarketScanToggleExpand = 'Web-App-Market-Scan-Toggle-Expand',
  MarketScanSurveyDoAnotherClick = 'Web-App-Market-Scan-Survey-Do-Another-Click',
  MarketScanUploadSuccessToastClick = 'Web-App-Market-Scan-Add-Upload-Notification-Click',
  MarketScanPartnerImageClick = 'Web-App-Market-Scan-Partner-Image-Click',
  MarketScanTravelClick = 'Web-App-Market-Scan-Travel-Get-Quote',
  MarketScanSwitchSaveSliderChange = 'Web-App-Market-Scan-Switch-Save-Slider-Change',
  MarketScanOutboundClick = 'Web-App-Market-Scan-Outbound',
  MarketScanSearch = 'Web-App-Market-Scan-Search-Benefits',
  MarketScanMakeModelMatch = 'Web-App-Market-Scan-Make-Model-Match',
  MarketScanPolicyWordingClick = 'Web-App-Market-Scan-Policy-Wording-Click',
  MarketScanVehicleRequestMakeModel = 'Web-App-Request-Vehicle-Make-Model',

  // MS Waiting
  WebAppMSWaitingViewed = 'Web-App-MS-Waiting-Viewed',
  WebAppMSWaitingLifeInsuranceClick = 'Web-App-MS-Waiting-Life-Insurance-Click',
  WebAppMSWaitingDoMoreScanClick = 'Web-App-MS-Waiting-Do-More-Scan-Click',
  WebAppMSReadyClick = 'Web-App-MS-Ready-Click',
  WebAppMSWaitingInReview = 'Web-App-MS-Waiting-In-Review',
  WebAppMSWaitingInReviewClick = 'Web-App-MS-Waiting-In-Review-Click',
  WebAppMSWaitingCarouselPrevClick = 'Web-App-MS-Waiting-Carousel-Prev-Click',
  WebAppMSWaitingCarouselNextClick = 'Web-App-MS-Waiting-Carousel-Next-Click',
  WebAppMSWaitingPolicyCompareFormEdit = 'Web-App-MS-Waiting-Policy-Compare-Form-Edit',
  WebAppMSWaitingPolicyCompareFormSubmit = 'Web-App-MS-Waiting-Policy-Compare-Form-Submit',
  WebAppMSWaitingSliderClose = 'Web-App-MS-Waiting-Slider-Close',
  WebAppMSWaitingPolicyCompareProviderClick = 'Web-App-MS-Waiting-Policy-Compare-Provider-Click',
  WebAppMSWaitingPolicyCompareSingleDateInputClick = 'Web-App-MS-Waiting-Policy-Compare-Single-Date-Input-Click',
  WebAppMSWaitingNewsMediaClick = 'Web-App-MS-Waiting-News-Media-Click',

  // MS Broker
  BrokerFormOpenedBanner = 'Web-App-Open-Broker-Form-Banner',
  BrokerFormOpenedFull = 'Web-App-Open-Broker-Form-Full',
  BrokerFormComplected = 'Web-App-Complete-Broker-Form',
  BrokerPolicyMakeClaim = 'Web-App-Broker-Make-Claim-Click',
  BrokerPolicyMakeChange = 'Web-App-Broker-Make-Change-Click',
  MarketScanBrokerConfirmationSubmit = 'Web-App-Broker-Confirmation-Submit',

  // MS Results
  MarketScanResultHelpClick = 'Web-App-Market-Scan-Result-Help-Click',
  MarketScanResultHelpOptionClick = 'Web-App-Market-Scan-Result-Help-Option-Click',
  MarketScanResultSeeMore = 'Web-App-Market-Scan-Result-See-More',
  MarketScanResultPurchasePopupClick = 'Web-App-Market-Scan-Result-Purchase-Popup-Click',
  MarketScanResultFaqsClick = 'Web-App-Market-Scan-Result-Faqs-Click',
  MarketScanResultsSwitchClick = 'Web-App-Market-Scan-Result-Switch-And-Save-Click',
  MarketScanResultsLearnMoreClick = 'Web-App-Market-Scan-Result-Learn-More-Click',
  MarketScanResultsFaqClick = 'Web-App-Market-Scan-Result-TS-FAQ-Click',

  // MS Purchase Flyout
  MarketScanFlyoutClose = 'Web-App-Market-Scan-Flyout-Close',
  MarketScanFlyoutGoToProviderClick = 'Web-App-Market-Scan-Flyout-Go-To-Provider-Click',
  MarketScanFlyoutEmailQuoteClick = 'Web-App-Market-Scan-Flyout-Email-Quote-Click',
  MarketScanFlyoutCopyQuoteRefClick = 'Web-App-Market-Scan-Flyout-Copy-Quote-Ref-Click',
  MarketScanRequestQuoteResultViewed = 'Web-App-Market-Scan-Request-Quote-Result-Viewed',

  // MS Life
  MarketScanLifeSubmit = 'Web-App-Market-Scan-Life-Submit',
  MarketScanLifeProviderSelect = 'Web-App-Market-Scan-Life-Provider-Select',
  MarketScanLifeAddonChange = 'Web-App-Market-Scan-Life-Addon-Change',
  MarketScanLifeAmountChange = 'Web-App-Market-Scan-Life-Amount-Change',
  MarketScanLifeContinue = 'Web-App-Market-Scan-Life-Get-Cover',
  MarketScanLifePersonalisedAdviceClick = 'Web-App-Market-Scan-Life-Personalised-Advice-Click',
  MarketScanLifeCallbackClick = 'Web-App-Market-Scan-Life-Callback-Click',

  // MS Life Purchase Flyout
  MarketScanLifeFlyoutClose = 'Web-App-Market-Scan-Life-Flyout-Close',
  MarketScanLifeFlyoutGoToProviderClick = 'Web-App-Market-Scan-Life-Flyout-Go-To-Provider-Click',

  // Survey
  SurveyOpen = 'Web-App-Survey-Open',
  SurveyStarted = 'Web-App-Survey-Started',
  SurveySubmitted = 'Web-App-Survey-Submitted',
  SurveyBuyNow = 'Web-App-Survey-Buy-Now',

  // Onboarding
  OnboardingOptionSelect = 'Web-App-Onboarding-Option-Select',
  OnboardingMsUpload = 'Web-App-Onboarding-Market-Scan-Upload',
  OnboardingMsSkip = 'Web-App-Onboarding-Market-Scan-Skip',
  OnboardingMsPolicyTypeSelect = 'Web-App-Onboarding-Market-Scan-Policy-Type-Select',
  OnboardingPolicyUpload = 'Web-App-Onboarding-Policy-Upload',

  // Shared dashboard
  SharedDashboardInvitationCreated = 'Web-App-Shared-Dashboard-Invitation-Created',
  SharedDashboardInvitationProcessed = 'Web-App-Shared-Dashboard-Invitation-Processed',

  // Policy details
  PolicyDetailsEdit = 'Web-App-Policy-Details-Edit',
  PolicyDetailsSave = 'Web-App-Policy-Details-Save',
  PolicyDetailsDelete = 'Web-App-Policy-Details-Delete',
  PolicyDetailsDocClick = 'Web-App-Policy-Details-Doc-Click',
  PolicyDetailsDocDelete = 'Web-App-Policy-Details-Doc-Delete',
  PolicyDetailsRenewalClick = 'Web-App-Policy-Details-Renewal-Click',
  PolicyDetailsTabChange = 'Web-App-Policy-Details-Tab-Change',
  PolicyDetailsPartnerModalVehicleClick = 'Web-App-Policy-Details-Partner-Modal-Vehicle-Click',
  PolicyDetailsPartnerModalHomeClick = 'Web-App-Policy-Details-Partner-Modal-Home-Click',

  // Policy renewal
  PolicyRenewalManualTabClick = 'Web-App-Policy-Renewal-Manual-Tab-Click',
  PolicyRenewalUploadTabClick = 'Web-App-Policy-Renewal-Upload-Tab-Click',
  PolicyRenewalManual = 'Web-App-Policy-Renewal-Manual',
  PolicyRenewalUpload = 'Web-App-Policy-Renewal-Upload',
  PolicyRenewalUpdated = 'Web-App-Policy-Renewal-Updated',
  PolicyRenewalCreated = 'Web-App-Policy-Renewal-Created',
  PolicyRenewalPendingCompleted = 'Web-App-Policy-Renewal-Pending-Completed',

  // Premium
  PremiumEngagementCreated = 'Web-App-Premium-Engagement-Created',
  PremiumEngagementUpdated = 'Web-App-Premium-Engagement-Updated',
  PremiumUploads = 'Web-App-Premium-Uploads',
  PremiumAddPolicy = 'Web-App-Premium-Add-Policy',
  PremiumMarketScanSubmit = 'Web-App-Premium-Market-Scan-Submit',

  // Q4E
  Q4EEmailConfirmError = 'Web-App-Q4E-Email-Confirm-Error',
  Q4EEmailVerificationError = 'Web-App-Q4E-Email-Verification-Error',
  Q4ENotEmployeeClick = 'Web-App-Q4E-Not-Employee-Click',
  Q4ELifeContinueClick = 'Web-App-Q4E-Life-Continue-Click',
  Q4EConfirmPurchaseClick = 'Web-App-Q4E-Confirm-Purchase-Click',
  Q4EConfirmPurchaseSubmit = 'Web-App-Q4E-Confirm-Purchase-Submit',

  // Experiments
  ConversionExperiment = 'Web-App-Conversion-Experiment',
  ConversionExperimentQ2 = 'Web-App-Conversion-Experiment-Q2',

  // Market Scan Survey Events
  MarketScanSubmitSurvey = 'Web-App-Market-Scan-Submit-Survey',
  MarketScanLeaveReview = 'Web-App-Market-Scan-Leave-Review',
  MarketScanNoReview = 'Web-App-Market-Scan-No-Review',

  // Auto MS Popup
  AutoScanPopup = 'Web-App-Auto-Scan-Popup',

  // How To Videos Popup
  HowToVideosPopup = 'Web-App-How-To-Videos-Popup',

  InspectRewardInfo = 'Web-App-Inspect-Reward-Info',
  RewardTagClick = 'Web-App-Reward-Tag-Click',

  // MS Addon Toggle
  MSAddonToggle = 'Web-App-MS-Addon-Toggle',

  // Sponsor Ads
  WebAppSponsorCreativeShow = 'Web-App-Sponsor-Creative-Show',
  WebAppSponsorCreativeClick = 'Web-App-Sponsor-Creative-Click',
}

export const getUserUniqId = () => {
  let uniqId = '';
  // Make sure the app is not broker
  // When Ad blocker install, user might not exist
  try {
    const analyticsUser = analytics.instance?.user();
    if (analyticsUser && analyticsUser.anonymousId) {
      uniqId = analyticsUser.anonymousId() || '';
    }
  } catch {
    // analytics not ready yet or ad blocker
  }
  return uniqId;
};

export const logEvent = (category: string, action: string, label: string) => {
  const uniqId = getUserUniqId();
  analytics.track(category, {
    category,
    action,
    label,
    externalId: uniqId,
    external_id: uniqId,
  });
};

export const trackEvent = (eventName: string, properties?: any) => {
  const uniqId = getUserUniqId();
  const props = properties || {};

  props.externalId = uniqId;
  props.external_id = uniqId;

  const newProps = R.omit(propsToOmit, props);
  analytics.track(eventName, newProps);
};

export const identify = (userId: string, properties: any) => {
  const firstName = properties['https://quashed.co.nz/firstName'];
  const lastName = properties['https://quashed.co.nz/lastName'];
  const userRole = properties['https://quashed.co.nz/role'];
  const email = properties['email'];
  const name = properties['name'];
  const phone = properties['phoneNumber'];
  const uniqId = getUserUniqId();
  analytics.identify(userId, {
    firstName,
    lastName,
    userRole,
    email,
    name,
    phone,
    id: userId,
    externalId: uniqId,
    external_id: uniqId,
  });

  trackEvent(TRACKING_EVENTS.UserLogin, { deviceType: getDeviceType() });
};

const getTrackingData = () => {
  const userClaims = getGlobalIdTokenClaims();
  return {
    userId: userClaims?.sub || getUserId(),
    deviceType: getDeviceType(),
  };
};

const getUserEmail = () => {
  const userClaims = getGlobalIdTokenClaims();
  return userClaims?.email;
};

export const trackEventWithUserId = (eventName: string) => {
  trackEvent(eventName, getTrackingData());
};

export const trackEventWithData = (eventName: string, data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(eventName, trackingData);
};

export const trackEventPolicyScan = () => {
  const trackingData = getTrackingData();
  trackEvent(FB_EVENTS.Contact, trackingData);
};

export const trackEventMarketScanView = (
  policyScan: IPolicyScan,
  experimentValue?: string | null,
  initioExperimentValue?: string | null,
  quoteRequestExperimentValue?: string | null,
  autosureExperimentValue?: string | null,
  ampExperimentValue?: string | null,
) => {
  trackEvent(TRACKING_EVENTS.MarketScanViewed, {
    marketScanId: policyScan?.id,
    policyType: policyScan?.policyType,
    ...(isVehiclePolicy(policyScan?.policyType || '') && {
      experimentValue: experimentValue,
      initioExperimentValue: initioExperimentValue,
      quoteRequestExperimentValue: quoteRequestExperimentValue,
      autosureExperimentValue: autosureExperimentValue,
    }),
    ...(ampExperimentValue && { ampExperimentValue }),
    deviceType: getDeviceType(),
  });
};

export const trackEventPolicyScanView = (policyScan: IPolicyScan) => {
  const trackingData = getTrackingData();
  const userEmail = getUserEmail()

  // Fields to remove from various parts of the payload
  const propertyFieldsToRemove = [
    'completedAt',
    'completedBy',
    'createdAt',
    'createdBy',
    'status',
    'userName',
    'updatedAt',
    'policySubTypeId',
    'policyTypeId',
  ];

  const quoteFieldsToRemove = [
    'benefitsHighlights',
    'policyProviderId',
    'referral_link',
  ];

  const policyFieldsToRemove = ['policyProviderId'];

  // Ensure policyScan and its quotes exist before proceeding
  if (!policyScan || !Array.isArray(policyScan.quotes)) {
    console.error('PolicyScan or its quotes are undefined or invalid.');
    return;
  }

  // Clone and merge tracking data with policy scan data
  const payloadData = R.clone(R.merge(trackingData, policyScan));
  payloadData.email = userEmail;
  // Remove unwanted fields from payloadData
  propertyFieldsToRemove.forEach((field) => {
    if (field in payloadData) {
      delete payloadData[field];
    }
  });

  // Remove unwanted fields from each quote in quotes array
  payloadData.quotes.forEach((quote) => {
    if (quote && typeof quote === 'object') {
      quoteFieldsToRemove.forEach((field) => {
        if (field in quote) {
          delete quote[field];
        }
      });
    }
  });

  // Ensure selectedProvider exists before modifying it
  if (
    payloadData.selectedProvider &&
    typeof payloadData.selectedProvider === 'object'
  ) {
    policyFieldsToRemove.forEach((field) => {
      if (field in payloadData.selectedProvider) {
        delete payloadData.selectedProvider[field];
      }
    });
  }

  // Track the events
  trackEvent(TRACKING_EVENTS.MarketScanBuy, payloadData);
  trackEvent(FB_EVENTS.Purchase, payloadData);
};

export const trackEventGetAdvice = (data: any) => {
  const trackingData = getTrackingData();
  trackEvent(TRACKING_EVENTS.GetAdviceSubmitted, {
    ...trackingData,
    ...data,
  });

  trackEvent(FB_EVENTS.Schedule, trackingData);
};

export const trackEventCoverageCompleted = () => {
  const trackingData = getTrackingData();
  trackEvent(TRACKING_EVENTS.InsuranceCheckupCompleted, trackingData);

  trackEvent(FB_EVENTS.Search, trackingData);
};

export const trackVoteFeedback = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  if (data.vote) {
    trackEvent(TRACKING_EVENTS.FeedbackUpvote, trackingData);
  } else {
    trackEvent(TRACKING_EVENTS.FeedbackDownvote, trackingData);
  }
};

export const trackNotesFeedback = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.FeedbackNotes, trackingData);
};

export const trackMarketScanPageChange = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPageChange, trackingData);
};

export const trackMSPurchasePageChange = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchasePageChange, trackingData);
};

export const trackPurchaseSaveDraft = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchaseSaveDraft, trackingData);
};

export const trackPurchasePay = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchasePay, trackingData);
};

export const trackPurchaseStripePay = (data: {
  policyProviderName: string;
  status: string;
  experimentValue?: string;
}) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchaseStripePay, trackingData);
};

export const trackPurchaseTermsDownload = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchaseTermsDownload, trackingData);
};

export const trackSharedInvitationCreated = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.SharedDashboardInvitationCreated, trackingData);
};

export const trackSharedInvitationProcessed = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.SharedDashboardInvitationProcessed, trackingData);
};

export const trackPolicyDetailsEdit = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsEdit, trackingData);
};

export const trackPolicyDetailsSave = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsSave, trackingData);
};

export const trackPolicyDetailsDelete = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsDelete, trackingData);
};

export const trackPolicyDetailsTabChange = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsTabChange, trackingData);
};

export const trackPolicyDetailsDocClick = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsDocClick, trackingData);
};

export const trackPolicyDetailsDocDelete = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyDetailsDocDelete, trackingData);
};

export const trackPolicyRenewalUpdated = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyRenewalUpdated, trackingData);
};

export const trackPolicyRenewalCreated = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyRenewalCreated, trackingData);
};

export const trackPolicyRenewalPendingCompleted = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PolicyRenewalPendingCompleted, trackingData);
};

export const trackNotificationClick = () => {
  const trackingData = getTrackingData();
  trackEvent(TRACKING_EVENTS.NotificationClick, trackingData);
};

export const trackMarketScanSubmitSurvey = (data: any = {}) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanSubmitSurvey, trackingData);
};

export const trackNotificationViewAllClick = () => {
  const trackingData = getTrackingData();
  trackEvent(TRACKING_EVENTS.NotificationViewAll, trackingData);
};

export const trackMSPolicyTypeSelect = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPolicyTypeSelect, trackingData);
};

export const trackMSDisclosureClick = () => {
  trackEvent(TRACKING_EVENTS.MarketScanDisclosureClick, getTrackingData());
};

export const trackMSResultHelpClick = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanResultHelpClick, trackingData);
};

export const trackMSResultHelpOptionClick = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanResultHelpOptionClick, trackingData);
};

export const trackMSResultSeeMore = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanResultSeeMore, trackingData);
};

export const trackMSBrokerConfirmationSubmit = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanBrokerConfirmationSubmit, trackingData);
};

export const trackMSPurchaseSuccess = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchaseSuccess, trackingData);
};

export const trackMSPurchaseFail = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanPurchaseFail, trackingData);
};

export const trackMarketScanEndScreenCta = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanEndScreenCta, trackingData);
};

export const trackMarketScanEndScreenAreYourCoveredCta = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.MarketScanEndScreenAreYouCoveredCta, trackingData);
};

export const trackPremiumEngagementCreated = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PremiumEngagementCreated, trackingData);
};

export const trackPremiumEngagementUpdated = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PremiumEngagementUpdated, trackingData);
};

export const trackPremiumUploads = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PremiumEngagementUpdated, trackingData);
};

export const trackPremiumAddPolicy = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PremiumAddPolicy, trackingData);
};

export const trackPremiumMarketScanSubmit = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.PremiumMarketScanSubmit, trackingData);
};

export const trackMarketScanCompareExistingClick = () => {
  trackEvent(TRACKING_EVENTS.MarketScanCompareExistingClick, getTrackingData());
};

export const trackOnboardingMsPolicyTypeSelect = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.OnboardingMsPolicyTypeSelect, trackingData);
};

export const trackOnboardingMsUpload = (data: any) => {
  const trackingData = R.merge(data, getTrackingData());
  trackEvent(TRACKING_EVENTS.OnboardingMsUpload, trackingData);
};

export const trackOnboardingMsSkip = () => {
  trackEvent(TRACKING_EVENTS.OnboardingMsSkip, getTrackingData());
};

export const trackOnboardingPolicyUpload = () => {
  trackEvent(TRACKING_EVENTS.OnboardingPolicyUpload, getTrackingData());
};
